import { Component, OnInit} from '@angular/core';
import { AuthenticationService } from '../../services/index';
import { Router } from '@angular/router';

@Component({
    templateUrl: 'exit.component.html'
})

export class ExitComponent implements OnInit {

    constructor(private authenticationService: AuthenticationService, private router: Router) { }

    ngOnInit() {
       this.authenticationService.logout()
       .subscribe();
    }
    logon() {
      this.router.navigate(['login']);
    }
}



// WEBPACK FOOTER //
// ./src/app/exit/exit.component.ts